export const DOWNLOAD_STATUS = {
  NOOP: 'noop',
  DOWNLOADED: 'downloaded',
  DOWNLOADING: 'downloading',
  DOWNLOAD_FAILED: 'download-failed',
}
